module.exports = __webpack_public_path__ + "static/img/感知_0.e8a2172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/感知_0.jpg
// module id = +CHG
// module chunks = 1